import React, {ForwardedRef, forwardRef} from 'react'

import {cn} from '@/src/shared/utils/twMerge'

const Body7 = forwardRef(
  (
    {children, className}: {children: React.ReactNode; className?: string},
    ref: ForwardedRef<HTMLParagraphElement>
  ) => {
    return (
      <p
        ref={ref}
        className={cn(
          'lg:text-xs',
          'text-[12px]',
          'text-gray-800',
          'font-normal',
          'leading-normal tracking-wide',
          className
        )}>
        {children}
      </p>
    )
  }
)

Body7.displayName = 'Body7'

export default Body7
